import { render, staticRenderFns } from "./hdi-index.vue?vue&type=template&id=7cc97e96&scoped=true"
import script from "./hdi-index.vue?vue&type=script&lang=js"
export * from "./hdi-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc97e96",
  null
  
)

export default component.exports